export default __webpack_public_path__ + "assets/bg_social_media_l.jpg";